import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventDetails } from 'src/app/models/events.model';
import { ComponentsCommunicationService } from 'src/app/services/components-communication.service';
import { EventsService } from "src/app/services/events.service";
declare var bootstrap: any;
@Component({
  selector: 'transflo-event-details',
  templateUrl: './event-details.component.html',
  styleUrl: './event-details.component.scss'
})
export class EventDetailsComponent implements OnInit {

  @Input() eventId: number = 0;
  eventDetails: EventDetails;
  documentMetadata: any[] = [];
  documentName: string = "";
  showPopup: boolean = false;
  modalElement: HTMLElement;
  modal: any;
  constructor(
    private eventsService: EventsService,
    private communicationService: ComponentsCommunicationService
  ) { }

  ngOnInit(): void {
    this.getEventDetails();

    this.modalElement = document.getElementById('eventDetailsModal');
    if (this.modalElement) {
      this.modal = new bootstrap.Modal(this.modalElement, { backdrop: true });
      this.modal.show();
    }
  }

  getEventDetails() {
    this.eventsService.getEvent(this.eventId).subscribe(
      (response: any) => {
        if (response && response.body) {
          this.eventDetails = response.body;
        }
      },
      (error) => {
        console.error('Error fetching event details:', error);
      }
    );
  }

  nextEvent() {
    this.eventsService.getEvent(this.eventId).subscribe(
      (response) => {
        if (response && response.body && response.body.Action && response.body.Action.Document &&
          response.body.Action.Document.MetaData && response.body.Action.Document.MetaData.length > 0) {
          this.documentMetadata = response.body.Action.Document.MetaData;
          this.documentName = response.body.Action.Document.Name;
          this.showPopup = true;
          console.log('in if: event id: ', this.eventId);
        }
        else if (response && response.body && response.body.Action && response.body.Action.Document &&
          response.body.Action.Document.MetaData && response.body.Action.Document.MetaData.length == 0) {
          const fleetId = localStorage.getItem('fleetId');
          const token = localStorage.getItem('token');
          const appScheme = 'transflomobileplus';
          let deepLinkUrl = `${appScheme}://scan?recipientid=${fleetId}&return=confnumber&fleetId=${fleetId}&token=${token}&eventId=${this.eventId}`;

          window.location.href = deepLinkUrl;
        }
        else {
          this.eventsService.CompleteEvent(this.eventId).subscribe(resp => {
            if (resp && resp.status === 204) {
              if (this.modalElement) {
                this.modal.hide();
              }
              this.communicationService.triggerRefresh();
            }
          });
        }
      },
      (error) => {
        console.error("Error fetching event data", error);
      }
    );
  }

  onClosePopup(): void {
    this.showPopup = false;
  }

  onSubmitForm(formData: any): void {
    console.log("Form submitted with data:", formData);
  }
}
